import axios, { AxiosResponse } from 'axios';
import { IRequestData, IResponseDataItem } from './find-liquidated-taxpayer.type';

export const url = '/services/isnaportalsync/open-api/find-liquidated-taxpayer';

export const getLiquidatedTaxpayerInfo = (
    request: IRequestData
): Promise<AxiosResponse<IResponseDataItem[]>> => {
    return axios.get(`${url}`, { params: request });
};

export const downloadExcel = (request: any): Promise<AxiosResponse> => {
    return axios.get(url, {
        params: { ...request, excel: true },
        responseType: 'blob',
        headers: {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
    });
};
